// src/components/LoadingScreen.jsx
import React, { useEffect, useState } from "react";

const loaderStyles = {
  container: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "#FBF9F3",
    color: "#212121",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "opacity 300ms ease",
    zIndex: 1000,
    opacity: 1,
    fontFamily: "'Inter', -apple-system, sans-serif",
  },
  inner: {
    width: 100,
    height: 3,
    background: "#FBF9F3",
    color: "#212121",
    textAlign: "center",
  },
  bar: {
    height: 3,
    width: "100%",
    background: "#212121",
    transition: "transform 200ms",
    transformOrigin: "left center",
  },
  data: {
    display: "inline-block",
    position: "relative",
    color: "#212121",
    fontSize: "14px",
    marginTop: "1em",
    fontWeight: 500,
    letterSpacing: "-0.01em",
  },
};

const LoadingScreen = ({ isVisible }) => {
  const [progress, setProgress] = useState(0);
  const [shouldRender, setShouldRender] = useState(isVisible);
  const [opacity, setOpacity] = useState(1);

  useEffect(() => {
    // Handle visibility changes with fade
    if (!isVisible) {
      setOpacity(0);
      const timer = setTimeout(() => {
        setShouldRender(false);
      }, 300); // Match transition duration
      return () => clearTimeout(timer);
    } else {
      setShouldRender(true);
      setOpacity(1);
    }
  }, [isVisible]);

  useEffect(() => {
    // Simulate loading progress
    const interval = setInterval(() => {
      setProgress((prev) => {
        const next = prev + (100 - prev) * 0.1;
        return next >= 99 ? 99 : next;
      });
    }, 100);

    return () => clearInterval(interval);
  }, []);

  if (!shouldRender) return null;

  return (
    <>
      <div
        style={{
          ...loaderStyles.container,
          opacity: opacity,
        }}
      >
        <div>
          <div style={loaderStyles.inner}>
            <div
              style={{
                ...loaderStyles.bar,
                transform: `scaleX(${progress / 100})`,
              }}
            />
            <span style={loaderStyles.data}>
              Loading {Math.round(progress)}%
            </span>
          </div>
        </div>
      </div>
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@500&display=swap');
        `}
      </style>
    </>
  );
};

export default LoadingScreen;
